import Avatar from '@components/avatar';
import { useSuiNSName } from '@hooks/use-sui-ns-name';
import { globalSettingModel } from '@models/global-setting.model';
import { NSFWOnOffModel } from '@models/on-off.model';
import { timeDifference } from '@utils/time-difference';
import { useModel } from 'foca';
import type { OpenapiClientPump } from 'src/openapi/pump';
import { type FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './list.module.scss';

interface OwnerProps {
  item: OpenapiClientPump.GetThreadListResponse['data'][number];
}

const List: FC<OwnerProps> = ({ item }) => {
  const onOff = useModel(NSFWOnOffModel, (state) => state['onoff']);
  const suiNames = useSuiNSName(item.wallet_address);

  return (
    <li className={styles.li}>
      <div className={styles.address}>
        <Avatar address={item.wallet_address} />
        <Link to={globalSettingModel.explorerUrlForAccount(item.wallet_address)} target="_blank">
          {suiNames || item.wallet_address.slice(item.wallet_address.length - 8)}
        </Link>
        <span>{timeDifference(item.created_at)} ago</span>
      </div>
      <div className={styles.content}>
        {item.attach_image && onOff && <img src={item.attach_image} />}
        <div className={styles.text}>{item.content}</div>
      </div>
    </li>
  );
};

export default List;
